import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import socket from '../utils/socket';

const NOTIFICATION_SOUND_URL = 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3';

const NotificationHandler = () => {
    const audioRef = useRef(null);

    useEffect(() => {
        const userDetailsStr = localStorage.getItem('zTaskUserDetails');
        const token = localStorage.getItem('zTaskAuthToken');

        if (token && userDetailsStr) {
            try {
                const user = JSON.parse(userDetailsStr);
                const userId = user.id;

                // Correctly extract roles based on your specific AuthHandler login logic
                let rolesArray = [];
                if (user.role && user.role.name) {
                    rolesArray = [user.role.name.toUpperCase()];
                } else if (user.claims && user.claims.roles) {
                    rolesArray = [user.claims.roles.toUpperCase()];
                } else if (typeof user.role === 'string') {
                    rolesArray = [user.role.toUpperCase()];
                }

                if (!socket.connected) {
                    socket.connect();
                }

                socket.emit('join', { userId, roles: rolesArray });

                const handleNotification = (data) => {
                    console.log('🔔 New Real-time Notification:', data);

                    // Play Sound
                    if (audioRef.current) {
                        audioRef.current.play().catch(e => console.warn('Sound play failed:', e));
                    }

                    // Show Toast
                    toast.info(data.message, {
                        position: "top-right",
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                };

                socket.on('notification', handleNotification);

                return () => {
                    socket.off('notification', handleNotification);
                    socket.disconnect();
                };
            } catch (err) {
                console.error('Socket init error:', err);
            }
        }
    }, []);

    return (
        <audio ref={audioRef} src={NOTIFICATION_SOUND_URL} preload="auto" />
    );
};

export default NotificationHandler;
